import React from "react";
import PropTypes from "prop-types";

const propTypes = {
  initial: PropTypes.any,
  children: PropTypes.func.isRequired,
};

/**
 * component for state encapsulation
 */
class State extends React.Component {
  state = { value: this.props.initial === undefined ? null : this.props.initial };
  set = val => {
    this.setState({ value: val });
  };
  setEventValue = e => {
    this.setState({ value: e.target.value });
  };
  clear = () => this.setState({ value: this.props.initial === undefined ? null : this.props.initial });
  render() {
    return this.props.children({
      state: this.state.value,
      set: this.set,
      setEventValue: this.setEventValue,
      clear: this.clear,
    });
  }
}

State.propTypes = propTypes;
export default State;



// WEBPACK FOOTER //
// ./src/components/State.jsx